import React, { useEffect, useRef } from "react";
import "./style.scss";
import { simplyClick } from "../../helpers";

const FooterMenu = () => {
  const elRef = useRef(null);

  useEffect(() => {
    const element = elRef.current;
    if (!element) return;

    const initText = element.textContent.trim();
    let previousText = element.textContent.trim();

    const observer = new MutationObserver(() => {
      const currentText = element.textContent.trim();
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "link_disclosures",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={"footer-menu"} ref={elRef}>
      <div className={"block"}>
        <a href="/terms-of-use/" target={"_blank"} rel="noreferrer">
          Terms of Use
        </a>
        <a href="/privacy-policy/" target={"_blank"} rel="noreferrer">
          Privacy Policy
        </a>
        <a href="/cookie-policy/" target={"_blank"} rel="noreferrer">
          Cookie Policy
        </a>
      </div>
      <div className={"block"}>
        <a href="/refund-policy/" target={"_blank"} rel="noreferrer">
          Refund Policy
        </a>
        <a href="/billing-policy/" target={"_blank"} rel="noreferrer">
          Billing Policy
        </a>
      </div>
      <div className={"block"}>
        <a href="/consent-policy/" target="_blank" ref={elRef} rel="noreferrer">
          Consent Policy
        </a>
        <a
          href="mailto: support@cupidlee.com"
          target={"_blank"}
          rel="noreferrer"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
};

export default FooterMenu;
